<template>
  <div>
    <b-card @click="$emit('set-config', dataConfig)" :title="title" class="nomina-widget-item2" :style="borderColor">
      <b-row>
        <b-col>
          <b-card-text>
              {{ description }}
            </b-card-text>
        </b-col>
        <b-col cols="6" sm="3">
          <i class="font-size-50 mr-3" :class="icon" :style="iconColor"/>
        </b-col>
      </b-row>
      <br>
    </b-card>
  </div>
</template>
<script>
export default {
  name: 'nominaWidgetItem2',
  props: {
    dataConfig: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: 'fe fe-server',
    },
    iconColor: {
      type: String,
      default: 'color: #3ea7df',
    },
    title: {
      type: String,
      default: 'nominaWidgetItem1',
    },
    description: {
      type: String,
      default: 'Some quick example text to build on the card title and make up the bulk of the card\'s content.',
    },
    borderColor: {
      type: String,
      default: 'border-top-color: #2b82b1;',
    },
  },
}
</script>

<style>
  .nomina-widget-item2 {
    border-top-width: 6px;
    border-top-style: solid;
    transition: transform .2s; /* Animation */
    cursor: pointer;
  }
  .nomina-widget-item2:hover {
    transform: scale(1.1); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  }
</style>
